import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    sealDetail: null,
    userInfo: null,
    locationInfo: null
  },
  mutations: {
    showLoading(state, isLoad) {
      state.isLoading = isLoad
    },
    setLocation(state, loactionInfo) {
      // console.log(loactionInfo);
      state.locationInfo = loactionInfo;
    },
    setSealDetail(state, sealDetail) {
      state.sealDetail = sealDetail;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo || {
        authenticationStatus: 1
      };
    }
  },
  getters: {
    getUserInfo(state) {
      let userInfo;
      // console.log(state);
      if (!state.userInfo) {
        userInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
      } else {
        userInfo = state.userInfo;
      }
      return userInfo;
    },
    getLocation(state) {
      let locationInfo = null;
      if (!state.locationInfo) {
        locationInfo = sessionStorage.getItem("locationInfo") && JSON.parse(sessionStorage.getItem("locationInfo"));
      } else {
        locationInfo = state.locationInfo;
      }
      return locationInfo;
    }
  },
  actions: {}
});